import { Box } from "@bca/ui-library";
import { useRouter } from "next/router";
import React, { useCallback, useEffect } from "react";

import FilterSkeleton from "../loading-skeleton/FilterSkeleton";
import addFiltersToPageUrl from "./addFiltersToPageUrl";
import CheckboxWithBadge from "./CheckboxWithBadge";

let timer;

const colour = {
  black: "#000000",
  grey: "#808080",
  blue: "#0000FF",
  white: "white",
  silver: "#C0C0C0",
  red: "#FF0000",
  green: "#008800",
  brown: "#6D1D1D",
  beige: "#F5F5DC",
  yellow: "#FFFF00",
  gold: "#FFD700",
  orange: "#FFA500",
  purple: "#800080",
  mauve: "#E0B0FF",
  pink: "#FF79E2",
  violet: "#EE82EE",
  bronze: "#CD7F32",
  cream: "#FFFDD0",
  maroon: "#800000",
  turquoise: "#30D5C8",
  "multi-colour": "multi-colour",
  unknown: "unknown",
};

const ColourFacet = ({
  filteredSubfilters,
  appliedCheckboxes,
  setAppliedCheckboxes,
  setSelectedVehicles,
}) => {
  const router = useRouter();

  const stringifiedFilters = JSON.stringify(appliedCheckboxes);
  const debounceUrlUpdate = useCallback(() => {
    clearTimeout(timer);

    timer = setTimeout(() => {
      const newUrl = addFiltersToPageUrl("bq", appliedCheckboxes);
      const currentPageUrl = new URL(window.location.href);
      if (newUrl.href === currentPageUrl.href) {
        return;
      }
      newUrl.searchParams.delete("page");
      newUrl.searchParams.delete("vrm");
      router.push(newUrl.href, newUrl.href, { shallow: true });
    }, 1000);
  }, [stringifiedFilters, appliedCheckboxes, router]);

  useEffect(() => {
    debounceUrlUpdate();
  }, [stringifiedFilters, debounceUrlUpdate]);

  const onChange = (filterKey, categoryKey) => {
    setSelectedVehicles([]);
    let newState = null;
    const filterAlreadyApplied = appliedCheckboxes.find(
      (item) =>
        item.filterKey.toLowerCase() === filterKey.toLowerCase() &&
        item.categoryKey.toLowerCase() === categoryKey.toLowerCase()
    );

    if (filterAlreadyApplied) {
      newState = [
        ...appliedCheckboxes.filter((item) => item !== filterAlreadyApplied),
      ];
    } else {
      newState = [
        ...appliedCheckboxes,
        {
          filterKey: filterKey,
          categoryKey: categoryKey,
          groupedBy: "",
          parentFilterKey: "",
        },
      ];
    }

    setAppliedCheckboxes([...newState]);
  };

  return (
    <>
      {!filteredSubfilters && <FilterSkeleton pairCount={2} />}
      {filteredSubfilters?.map(({ filterKey, filterValues }) => {
        const isFilterKey =
          filterValues?.length === 1 && filterValues[0].name === filterKey;
        if (isFilterKey) {
          return (
            <Box key={filterKey}>
              <CheckboxWithBadge
                key={filterKey}
                filterKey={filterKey}
                count={filterValues[0].count}
                iconColor={colour[filterKey.toLowerCase()]}
                iconText=""
                onChange={() => onChange(filterKey, "ColourGeneric")}
                isSelected={Boolean(
                  appliedCheckboxes.find(
                    (item) =>
                      item.filterKey.toLowerCase() ===
                        filterKey.toLowerCase() &&
                      (item.categoryKey === "ColourGeneric" ||
                        item.categoryKey === "colourgeneric")
                  )
                )}
              ></CheckboxWithBadge>
            </Box>
          );
        } else return null;
      })}
    </>
  );
};

export default ColourFacet;
